import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import Moment from "react-moment";
import MenuNav from "./MenuNav/MenuNav";
import AppContext from "../../../Context/AppContext";
import "./HeaderDashboard.css";

const HeaderDashboard = () => {
  const { checkUserSession, updateUserStepId,logOut } = useContext(AppContext);
  const infoUs = checkUserSession();

  const today = new Date();
  return (
    <>
      <MenuNav />
      <div className="HeaderDashboard__container div">
        <div className="HeaderName__container">
          <h2 className="name-login">
            ({infoUs.CarGclave}){infoUs.GesRazonSocial}
          </h2>
          <h3>
            Hermosillo,Son{" "}
            <span>
              <Moment locale="es" format="DD-MMM-YYYY" date={today}/>
            </span>
          </h3>
        </div>
        <div className="GestionesRegistradas__container">
          <h4>
          </h4>
        </div>
        <div className="btnCerrarSesion__container">
          <Button className="btnCerrarSesion" onClick={()=>logOut()}>Cerrar sesión</Button>
        </div>
      </div>
    </>
  );
};
export default HeaderDashboard;
